export type JsonLdValue = Record<string, any> | any[]

export const defaultOrganizationName = '杭州岁羽网络科技有限公司'

export function absoluteUrl(siteUrl: string, p: string) {
  const base = String(siteUrl || '').replace(/\/+$/, '')
  const s = String(p || '').trim()
  if (!s) return ''
  if (/^https?:\/\//.test(s)) return s
  const path = s.startsWith('/') ? s : `/${s}`
  return `${base}${path}`
}

export function organizationJsonLd(siteUrl: string, logoUrl: string) {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${String(siteUrl || '').replace(/\/+$/, '')}#organization`,
    name: defaultOrganizationName,
    url: String(siteUrl || '').replace(/\/+$/, ''),
    logo: { '@type': 'ImageObject', url: logoUrl },
  })
}

export function webApplicationJsonLd(opts: { siteUrl: string; name: string; description?: string; inLanguage?: string }) {
  const siteUrl = String(opts.siteUrl || '').replace(/\/+$/, '')
  const name = String(opts.name || '').trim()
  const description = String(opts.description || '').trim()
  const inLanguage = String(opts.inLanguage || '').trim() || 'zh-CN'
  const out: any = {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    '@id': `${siteUrl}#webapp`,
    name,
    applicationCategory: 'MultimediaApplication',
    operatingSystem: 'WebBrowser',
    url: siteUrl,
    inLanguage,
    provider: { '@id': `${siteUrl}#organization` },
  }
  if (description) out.description = description
  return JSON.stringify(out)
}
